module.exports = __webpack_public_path__ + "static/media/puzzlepiece1.52c240a0.svg";